import React from 'react'
import { useNavigate } from 'react-router-dom'
import { Typography, Grid, Box, Tooltip } from '@mui/material'
import { toast } from 'react-toastify'

const DocumentList = ({
  data,
  title,
  basePath,
  iconPath,
  navigatePath,
  noFilesMessage = 'No files available',
}) => {
  const navigate = useNavigate()

  const getFileIcon = (filename) => {
    const ext = filename?.split('.').pop().toLowerCase()
    switch (ext) {
      case 'pdf':
        return iconPath
          ? basePath + iconPath
          : basePath + 'DOCTYPE_ICONS/PDF_Icon.svg'
      case 'docx':
        return iconPath
          ? basePath + iconPath
          : basePath + 'DOCTYPE_ICONS/Doc_Icon.svg'
      default:
        return iconPath
          ? basePath + iconPath
          : basePath + 'DOCTYPE_ICONS/empty_icon.svg'
    }
  }

  const handleFileClick = (file) => {
    if (file.externalLink) {
      const isAbsoluteUrl = /^https?:\/\//i.test(file.externalLink)

      const fullUrl = isAbsoluteUrl
        ? file.externalLink
        : window.location.origin + file.externalLink

      window.open(fullUrl, '_blank')
      return
    }

    if (!file.pathurl) {
      toast.error('There is no file', {
        position: toast.POSITION.TOP_RIGHT,
      })
      return
    }

    navigate(`${navigatePath}/${file.ID}/${file.filename}`, {
      state: { selectedDocData: file, fromList: navigatePath },
    })
  }

  return (
    <section className="container py-4">
      {data.map((item, index) => (
        <div key={index} style={{ marginBottom: '2rem' }}>
          <Typography
            variant="h4"
            component="h1"
            sx={{
              fontWeight: 'bold',
              mb: '2rem',
              textAlign: 'center',
              color: '#494798',
              display: 'inline-block',
              position: 'relative',
              mx: 'auto',
              '&::after': {
                content: '""',
                position: 'absolute',
                left: 0,
                bottom: -6,
                width: '100%',
                height: '4px',
                background: 'linear-gradient(to right, #F15215, #494798)',
                borderRadius: '4px',
              },
            }}
          >
            {title} {item.Year ? `(${item.Year})` : ''}
          </Typography>

          <Grid container spacing={3}>
            {item.documents && item.documents.length > 0 ? (
              item.documents.map((file, idx) => (
                <Grid item xs={12} sm={6} md={4} lg={3} key={idx}>
                  <Box
                    onClick={() => handleFileClick(file)}
                    sx={{
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                      height: '240px',
                      padding: '1.5rem',
                      borderRadius: '16px',
                      backgroundColor: '#ffffff',
                      border: '1px solid #e0e0e0',
                      boxShadow: '0px 6px 16px rgba(0, 0, 0, 0.08)',
                      cursor: 'pointer',
                      transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                      '&:hover': {
                        transform: 'translateY(-6px)',
                        boxShadow: '0px 10px 20px rgba(0, 0, 0, 0.15)',
                      },
                    }}
                  >
                    <Box sx={{ flexGrow: 1, textAlign: 'center' }}>
                      <img
                        src={getFileIcon(basePath + file.pathurl)}
                        alt="File Icon"
                        loading="lazy"
                        placeholder="blur"
                        style={{
                          width: '100%',
                          height: 'auto',
                          marginBottom: '1rem',
                        }}
                      />
                    </Box>

                    <Tooltip title={file.filename} placement="top" arrow>
                      <Typography
                        variant="body2"
                        sx={{
                          fontWeight: 600,
                          textAlign: 'center',
                          color: '#2d3748',
                          mt: 'auto',
                          whiteSpace: 'nowrap',
                          overflow: 'hidden',
                          maxWidth: '100%',
                          textOverflow: 'ellipsis',
                          cursor: 'pointer', // Make it clear that it's interactive
                        }}
                      >
                        {file.filename}
                      </Typography>
                    </Tooltip>
                  </Box>
                </Grid>
              ))
            ) : (
              <Typography
                variant="body1"
                sx={{
                  textAlign: 'center',
                  width: '100%',
                  color: '#757575',
                  marginTop: '1rem',
                }}
              >
                {noFilesMessage}
              </Typography>
            )}
          </Grid>
        </div>
      ))}
    </section>
  )
}

export default DocumentList
